<template>
  <div class="container">
    <content-title :nav="nav"></content-title>
    <el-form :inline="true">
      <el-form-item label="用户ID">
        <el-input
          v-model="query.user_id"
          placeholder="用户ID"
          clearable
          style="width: 130px"
        ></el-input>
      </el-form-item>
      <el-form-item label="真实姓名">
        <el-input
          v-model="query.real_name"
          placeholder="真实姓名"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input
          v-model="query.phone"
          placeholder="联系电话"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" placeholder="选择" clearable>
          <el-option label="待审核" :value="0"></el-option>
          <el-option label="已通过" :value="1"></el-option>
          <el-option label="已拒绝" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="openCreate">直接创建合伙人</el-button>
      </el-form-item>
    </el-form>

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #invite_code="{ row }">
        <div v-if="row.invite_code">
          <span>{{ row.invite_code }}</span>
          <i
            class="el-icon-document-copy copy"
            @click="copyText(row.invite_code)"
          ></i>
        </div>
        <span v-else>-</span>
      </template>
      <template #status="{ row }">
        <el-tag size="small" type="warning" v-if="row.status === 0"
          >待审核</el-tag
        >
        <el-tag size="small" type="success" v-if="row.status === 1"
          >已通过</el-tag
        >
        <el-tag size="small" type="danger" v-if="row.status === 2"
          >已拒绝</el-tag
        >
      </template>
      <template #handle="{ row }">
        <el-button
          size="small"
          type="success"
          v-if="row.status === 0"
          @click="openAudit(row)"
          >审核</el-button
        >
        <el-button size="small" type="primary" @click="openUpdate(row)"
          >编辑</el-button
        >
        <el-button size="small" type="danger" @click="del(row)">删除</el-button>
      </template>
    </auto-table>

    <!-- 直接创建合伙人 -->
    <el-dialog title="直接创建合伙人" :visible.sync="createShow" width="40%">
      <el-form :model="createForm" :rules="createRules" ref="createForm" label-width="100px">
        <el-form-item label="用户" required prop="user_id">
          <user-select
            :userid.sync="createForm.user_id"
            @change="changeUser"
          ></user-select>
        </el-form-item>
        <el-form-item label="真实姓名" prop="real_name">
          <el-input
            v-model="createForm.real_name"
            placeholder="真实姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input
            v-model="createForm.phone"
            placeholder="联系电话"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createShow = false">取 消</el-button>
        <el-button type="primary" :loading="createLoading" @click="submitCreate"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog title="合伙人审核" :visible.sync="auditShow" width="35%">
      <el-form label-width="90px">
        <el-form-item label="申请人">{{
          curRow.real_name || curRow.user_id
        }}</el-form-item>
        <el-form-item label="联系电话">{{
          curRow.phone
        }}</el-form-item>
        <el-form-item label="审核结果">
          <el-radio-group v-model="auditStatus">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="拒绝原因" v-if="auditStatus === 2" required>
          <el-input
            type="textarea"
            :rows="4"
            v-model="reject_reason"
            maxlength="200"
            show-word-limit
            placeholder="请输入拒绝原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditShow = false">取 消</el-button>
        <el-button type="primary" :loading="auditLoading" @click="submitAudit"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 编辑 -->
    <el-dialog title="编辑合伙人" :visible.sync="updateShow" width="35%">
      <el-form :model="updateForm" ref="updateForm" label-width="100px">
        <el-form-item label="用户ID">{{
          updateForm.user_id
        }}</el-form-item>
        <el-form-item label="真实姓名">
          <el-input
            v-model="updateForm.real_name"
            placeholder="真实姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input
            v-model="updateForm.phone"
            placeholder="联系电话"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateShow = false">取 消</el-button>
        <el-button type="primary" :loading="updateLoading" @click="submitUpdate"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nav: { firstNav: "商城管理", secondNav: "合伙人管理" },
      DataList: [],
      Total: 0,
      query: {
        user_id: "",
        real_name: "",
        phone: "",
        status: "",
      },
      Option: [
        { name: "ID", value: "id", width: "80px" },
        { name: "用户ID", value: "user_id" },
        { name: "真实姓名", value: "real_name" },
        { name: "联系电话", value: "phone" },
        { name: "邀请码", value: "invite_code", type: "custom", width: "150px" },
        { name: "状态", value: "status", type: "custom" },
        { name: "审核人", value: "audit_operator_id" },
        { name: "审核时间", value: "audit_time", width: "160px" },
        { name: "拒绝原因", value: "reject_reason" },
        { name: "创建时间", value: "create_time", width: "160px" },
        { name: "操作", value: "handle", type: "custom", width: "220px" },
      ],
      curRow: {},
      createShow: false,
      createLoading: false,
      createForm: {
        user_id: "",
        real_name: "",
        phone: "",
      },
      createRules: {
        user_id: [
          { required: true, message: "请选择用户", trigger: "change" },
        ],
      },
      auditShow: false,
      auditStatus: 1,
      reject_reason: "",
      auditLoading: false,
      updateShow: false,
      updateLoading: false,
      updateForm: {},
      adminInfo: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    copyText(v) {
      navigator.clipboard.writeText(v).then(() => {
        this.$message("复制成功");
      });
    },
    changeUser(item) {
      if (item && item.login_name && !this.createForm.phone) {
        this.createForm.phone = item.login_name;
      }
    },
    openCreate() {
      this.createForm = {
        user_id: "",
        real_name: "",
        phone: "",
      };
      this.createShow = true;
      this.$nextTick(() => {
        if (this.$refs.createForm) {
          this.$refs.createForm.clearValidate();
        }
      });
    },
    submitCreate() {
      this.$refs.createForm.validate((valid) => {
        if (valid) {
          this.createLoading = true;
          this.$axios({
            url: "/user/partnerApply/adminCreate",
            method: "post",
            data: {
              user_id: this.createForm.user_id,
              real_name: this.createForm.real_name,
              phone: this.createForm.phone,
              audit_operator_id: this.adminInfo.id,
            },
          })
            .then((res) => {
              this.$alert(
                `已开通为合伙人，专属邀请码：${res.data.data}`,
                "创建成功",
                {
                  confirmButtonText: "知道了",
                  callback: () => {},
                }
              );
              this.createShow = false;
              this.createLoading = false;
              this.getList(1);
            })
            .catch(() => {
              this.createLoading = false;
            });
        }
      });
    },
    openAudit(row) {
      this.curRow = row;
      this.auditStatus = 1;
      this.reject_reason = "";
      this.auditShow = true;
    },
    submitAudit() {
      if (this.auditStatus === 2 && !this.reject_reason) {
        this.$message("拒绝时必须填写拒绝原因");
        return;
      }
      this.auditLoading = true;
      this.$axios({
        url: "/user/partnerApply/audit",
        method: "post",
        data: {
          id: this.curRow.id,
          status: this.auditStatus,
          reject_reason: this.reject_reason,
          audit_operator_id: this.adminInfo.id,
        },
      })
        .then((res) => {
          this.$message.success(this.auditStatus === 1 ? "已通过" : "已拒绝");
          this.auditShow = false;
          this.auditLoading = false;
          this.getList(1);
        })
        .catch(() => {
          this.auditLoading = false;
        });
    },
    openUpdate(row) {
      this.updateForm = {
        id: row.id,
        user_id: row.user_id,
        real_name: row.real_name,
        phone: row.phone,
      };
      this.updateShow = true;
    },
    submitUpdate() {
      this.updateLoading = true;
      this.$axios({
        url: "/user/partnerApply/update",
        method: "post",
        data: {
          id: this.updateForm.id,
          real_name: this.updateForm.real_name,
          phone: this.updateForm.phone,
        },
      })
        .then((res) => {
          this.$message.success("更新成功");
          this.updateShow = false;
          this.updateLoading = false;
          this.getList(1);
        })
        .catch(() => {
          this.updateLoading = false;
        });
    },
    del(row) {
      this.$confirm("确定删除该合伙人记录吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios({
            url: "/user/partnerApply/delete",
            data: {
              id: row.id,
            },
            method: "post",
          }).then((res) => {
            this.$message.success("删除成功");
            this.getList(1);
          });
        })
        .catch(() => {});
    },
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/partnerApply/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          user_id: this.query.user_id || null,
          real_name: this.query.real_name || null,
          phone: this.query.phone || null,
          status: this.query.status,
        },
      }).then((res) => {
        this.DataList = (res.data.data && res.data.data.rows) || [];
        this.Total = (res.data.data && res.data.data.total) || 0;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.copy {
  color: rgb(62, 136, 206);
  margin-left: 4px;
  cursor: pointer;
}
</style>
